import * as Sentry from "@sentry/react";
import { getPlatformType } from "shared/utils/platform";
import { filterBreadcrumb, shouldDropEvent } from "./sentryFilters";

const sentryDsn =
  process.env.REACT_APP_SENTRY_DSN ||
  "https://7d4f4c17e8b864566bad9f5f76aea50c@o4511394254684160.ingest.us.sentry.io/4511394259140608";

const isDevelopment = process.env.NODE_ENV === "development";

export const initSentry = () => {
  if (!sentryDsn) return;

  const platformType = getPlatformType();

  Sentry.init({
    dsn: sentryDsn,
    enabled: process.env.NODE_ENV !== "test",
    environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({
        traceFetch: false,
        traceXHR: false,
      }),
      Sentry.replayIntegration(),
    ],
    // Plano gratuito: 5.000 erros, 5M spans e 50 replays por mês. Sem
    // amostragem a cota inteira acabava nas primeiras horas do ciclo.
    sampleRate: isDevelopment ? 1.0 : 0.01,
    tracesSampleRate: isDevelopment ? 1.0 : 0.005,
    beforeSend: (event) => (shouldDropEvent(event) ? null : event),
    beforeBreadcrumb: filterBreadcrumb,
    tracePropagationTargets: ["localhost", /^http:\/\/localhost:\d+/],
    replaysSessionSampleRate: isDevelopment ? 1.0 : 0,
    replaysOnErrorSampleRate: isDevelopment ? 1.0 : 0.01,
    enableLogs: true,
  });

  Sentry.setTag("platformType", platformType);
  Sentry.setContext("platform", {
    type: platformType,
  });
};
